export default __webpack_public_path__ + "static/media/Hawk.b2c75064.png";